import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import { ADMIN_USERS_PAGE_SIZE, buildBrowseRequest, buildLookupRequest } from './usersListRequest';

export { ADMIN_USERS_PAGE_SIZE, buildBrowseRequest, buildLookupRequest };

/**
 * Admin users list. Callables only — no client Firestore reads of users, properties, or email indexes.
 * @param {{ mode: string, pageSize?: number, pageToken?: string, email?: string, uid?: string }} request
 */
export async function listAdminUsers(request) {
  const fn = httpsCallable(functions, 'listAdminUsers');
  const { data } = await fn(request);
  return data;
}

/**
 * Users 360 payload. Callables only.
 * @param {string} targetUid
 */
export async function getAdminUser(targetUid) {
  const fn = httpsCallable(functions, 'getAdminUser');
  const { data } = await fn({ targetUid });
  return data;
}
